import React, { useRef, useState, useEffect } from "react";
import { useNavigate, Link, useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Pagination } from "semantic-ui-react";
import { SERVER_URL } from "../config";
import SocietyJournalImg from "../assets/assets_html/images/society homepage.png";
import pg01 from "../assets/assets_html/images/perv_arrow.png";
import pg02 from "../assets/assets_html/images/next_arrow.png";
import NewsLetter from "../components/global/NewsLetter";
import JournalMainBanner from "../components/journals/JournalMainBanner";
import AakashgangaHeader from "../components/global/HeaderComponent";
import AakashgangaFooter from "../components/global/FooterComponent";
import Modal from "react-bootstrap/Modal";
import YoutubeIcon from "../assets/assets_html/images/Youtube-Icon.svg";
import coin from "../assets/img/icons/coinT.svg";
import {
  getJournalDetailById,
  getPEForJournalHomePage,
} from "../store/apiCalls/dashboard";
import SubmitArticleModal from "../components/Modal/SubmitArticleModal";
import { toast } from "react-toastify";
import { Accordion } from "react-bootstrap";
import { Helmet } from 'react-helmet';

const SocietyEditorialBoardMembers = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const journalName = location?.state?.journalName;
  const journalId = location?.state?.journalId;
  const token = localStorage.getItem("usertoken");
  const { id, discipline } = params;
  const navigate = useNavigate();
  const limit = 10;
  const [page, setPage] = useState(1);
  const [activeType, setActiveType] = useState("editorial-board-members");
  const societyJournal = "Society Journal";
  const [show, setShow] = useState(false);
  const [showRec, setShowRec] = useState(false);
  const [showAdvertising, setShowAdvertising] = useState(false);

  const pageName = location?.state?.pageName;
  const SHARE_URL = `${SERVER_URL}/explore-journals/${id}`;
  const [modalPageName, setModalPageName] = useState(pageName);
  const [modalJournalName, setJournalModalName] = useState(journalName);

  const [publishEditorData, setPublishEditorData] = useState([]);
  const [uploadArticle, setUploadArticle] = useState(false);
  let totalPages = Math.ceil(publishEditorData?.totalCount / limit);
  const [journalData, setJournalData] = useState(null);

  const handleRedirect = (e, path = "/registration") => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();

    // Add the "th" suffix to the day
    let daySuffix = "th";
    if (day === 1 || day === 21 || day === 31) {
      daySuffix = "st";
    } else if (day === 2 || day === 22) {
      daySuffix = "nd";
    } else if (day === 3 || day === 23) {
      daySuffix = "rd";
    }

    return ` ${month} ${day},  ${year}`;
  }

  const getJournalDetail = async () => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const reqParams = id ? { slug: id } : { journalId };
    const response = await getJournalDetailById(headers, reqParams);
    if (response?.status === 200) {
      setJournalData(response?.data?.data);
    }
  };

  const getPublishingEditorForJournal = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      journal: journalName || journalData?.journalName,
      page: 1,
      limit,
    };
    const response = await getPEForJournalHomePage(headers, params);
    dispatch({ type: "SET_LOADER", payload: false });
    if (response?.status === 200) {
      setPublishEditorData(response?.data?.data);
    }
  };

  const handlePageChange = (data) => {
    return setPage(data?.activePage);
  };

  useEffect(() => {
    getJournalDetail();
  }, [id, journalId]);

  useEffect(() => {
    if (journalName || journalData?.journalName) {
      getPublishingEditorForJournal();
    }
  }, [journalName, journalData?.journalName, page]);

  const membersList =
    journalData?.editorialBoardMembers ||
    journalData?.editorialMembers ||
    journalData?.editorialBoardMember ||
    journalData?.members ||
    [];

  const isCommunityLearning = (id === "community-learning-and-social-transformation" ||
    journalData?.journalName?.toLowerCase().includes("community learning") ||
    journalData?.slug === "community-learning-and-social-transformation");
  
  const boardTitle = isCommunityLearning ? "Editorial Advisory Board" : "Editorial Board Members";

  return (
    <>
      <Helmet>
        <title>{journalData?.journalName ? `${journalData?.journalName} - ${boardTitle}` : boardTitle}</title>
      </Helmet>
      <div className="tagbody">
        <AakashgangaHeader />
        <Link to={`/society-journals/${discipline}/${id}`}>
          <JournalMainBanner
            imgUrl={journalData?.masthead || SocietyJournalImg}
          />
        </Link>
        <div className="menu-center-part dsmar-25">
          <div className="journalShadow">
            <div className="ag_menu justify container journalBannercontainer" style={{ paddingLeft: '120px', paddingRight: '120px' }}>
              <ul className="ag_menu ag_menuSub justify tagul" style={{ width: '100%', justifyContent: 'space-between' }}>
                <li>
                  <a href="javascript:;" className="custom-journal taga">
                    <span className="text-black text-uppercase">
                      {journalData?.subjectData?.[0]?.subject?.subjectName || journalData?.discipline || discipline?.replace(/-/g, " ")}
                    </span>
                  </a>
                </li>
                <li className="active tagli custom-journal">
                  <Link
                    to="/open-access"
                    onClick={(e) => handleRedirect(e, "/open-access")}
                    className="custom-journal taga"
                  >
                    OPEN SCIENCE
                  </Link>
                </li>
                <li>
                  <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank" rel="noreferrer" className="custom-journal taga">
                    <img style={{ width: '100px', maxWidth: '100%', transform: 'none' }} src={coin} alt="#" />
                  </a>
                </li>
                {Boolean(journalData?.issnNumber && String(journalData.issnNumber).trim() !== "" && !/^[xX\-\s]+$/.test(String(journalData.issnNumber).trim()) && String(journalData.issnNumber).trim().toUpperCase() !== "NA" && String(journalData.issnNumber).trim().toUpperCase() !== "N/A") && (
                  <li>
                    <a href="javascript:;" className="custom-journal taga">
                      E-ISSN{" "}
                      <span className="colr">
                        {journalData?.issnNumber}
                      </span>
                    </a>
                  </li>
                )}
                <li>
                  <a href="javascript:;" className="custom-journal taga">
                    ABBR{" "}
                    <span className="colr">
                      {journalData?.abbreviation}
                    </span>
                  </a>
                </li>
                <li>
                  <a href="javascript:;" className="custom-journal taga">
                  FIRST PUBLISHED{" "}
                    <span className="colr">
                      {" "}
                      {""}
                      <div dangerouslySetInnerHTML={{__html:formatDate(journalData?.createdAt)}}></div>
                    </span>
                  </a>
                </li>
                {/* {journalData?.doiurl && (
                  <li>
                    <span className="colr">
                      <a className="text-lowercase" href={`https://doi.org/${journalData?.doiurl}`}>
                        https://doi.org/{journalData?.doiurl}
                      </a>
                    </span>
                  </li>
                )} */}
              </ul>
            </div>
          </div>

          <div className="editorContainer">
            <div className="editorPage">
              <span className="editorHead">{boardTitle}</span>
              <div className="journalBackWrap">
                <Link to={`/society-journals/${discipline}/${id}`}>
                  <span>Society Homepage</span>
                </Link>

                {!token ? (
                  <Link
                    to="/login"
                    onClick={(e) => {
                      e.preventDefault();
                      handleRedirect(e, "/login");
                    }}
                    className="ag_btn_red ag_btn_redclr"
                  >
                    Submit Article
                  </Link>
                ) : (
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      setUploadArticle(true);
                    }}
                    className="ag_btn_red ag_btn_redclr"
                  >
                    Submit Article
                  </Link>
                )}
              </div>
            </div>

            <div className="bg journals-main-div d-flex">
              <div className="div70">
                <div className="editorial-members-list pe-5">
                  {membersList && membersList.length > 0 ? (
                    membersList.map((item, ind) => {
                      const rawName = (item?.fullName || item?.name || "").trim();
                      const rawTitle = (item?.title || "").trim();
                      let displayName = rawName;
                      if (rawTitle && !rawName.toLowerCase().startsWith(rawTitle.toLowerCase())) {
                        displayName = `${rawTitle} ${rawName}`;
                      }

                      return (
                        <div className="editorial-member-item" key={ind}>
                          <h4 className="editorial-member-name">
                            {displayName}
                            {item?.email && (
                              <span className="editorial-member-email">
                                {" "}({item?.email})
                              </span>
                            )}
                          </h4>
                          {item?.designation && (
                            <p className="editorial-member-info">{item?.designation.trim()}</p>
                          )}
                          {item?.workPlace && item?.workPlace.trim() !== item?.designation?.trim() && (
                            <p className="editorial-member-info">{item?.workPlace.trim()}</p>
                          )}
                          {(item?.nameOfUniversityInstituteCompanyHospital ||
                            item?.nameOfUniversity ||
                            item?.university ||
                            item?.institute ||
                            item?.hospital ||
                            item?.company) && (
                            <p className="editorial-member-info">
                              {(
                                item?.nameOfUniversityInstituteCompanyHospital ||
                                item?.nameOfUniversity ||
                                item?.university ||
                                item?.institute ||
                                item?.hospital ||
                                item?.company
                              ).trim()}
                            </p>
                          )}
                          {item?.address && (
                            <p className="editorial-member-info">{item?.address.trim()}</p>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <p className="editorial-member-info">No {boardTitle} Data Found</p>
                  )}
                </div>
              </div>

              <div className="div30">
                <div className="journalslist custom-journalist-class">
                  <div className="align-items-center">
                    <div className="ag_heading_center_wrap our-partner mt-0 info-custom">
                      <h2 className="tagh2">Information</h2>
                    </div>
                  </div>
                  <ul className="journalInfoList">
                    <li className="custom-li-journal tagli">
                      <Link to={`/society-journals/${discipline}/${id}`}>
                        Description
                      </Link>
                    </li>
                    <li className="custom-li-journal tagli">
                      <Link to={`/society-journals/${discipline}/${id}`} state={{ scrollTo: "aimsandscope" }}>
                        Aims and Scope
                      </Link>
                    </li>
                    <li className="custom-li-journal tagli">
                      <Link to={`/society-journals/${discipline}/${id}/editorial-board`}>
                        Editorial Board
                      </Link>
                    </li>
                    {(id === "community-learning-and-social-transformation" ||
                      journalData?.journalName?.toLowerCase().includes("community learning") ||
                      journalData?.slug === "community-learning-and-social-transformation") && (
                      <li className="custom-li-journal tagli">
                        <Link
                          to={`/society-journals/${discipline}/${id}/editorial-board-members`}
                          className="active"
                        >
                          Advisory Board
                        </Link>
                      </li>
                    )}
                    <li className="custom-li-journal tagli">
                      <Link
                        to="/author-submission-guidelines"
                        target="_blank"
                      >
                        Author Guidelines
                      </Link>
                    </li>
                    <li className="custom-li-journal tagli">
                      <Link
                        className={activeType === "content-type" ? "active" : null}
                        onClick={(e) => {
                          e.preventDefault();
                          setShow(true);
                        }}
                      >
                        Content Type
                      </Link>
                    </li>
                    <li className="custom-li-journal tagli">
                      <Link
                        className={activeType === "recommend" ? "active" : null}
                        onClick={(e) => {
                          e.preventDefault();
                          setShowRec(true);
                        }}
                      >
                        Recommend
                      </Link>
                    </li>
                    <li className="custom-li-journal tagli">
                      <Link
                        className={activeType === "advertising" ? "active" : null}
                        onClick={(e) => {
                          e.preventDefault();
                          setShowAdvertising(true);
                        }}
                      >
                        Advertise With Us
                      </Link>
                    </li>
                    <li className="custom-li-journal tagli">
                      <Link to="/registration">Become a Reviewer</Link>
                    </li>
                    <li className="custom-li-journal tagli">
                      <Link to="/journal/get-in-touch" target="_blank">
                        Get in Touch
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <NewsLetter />
        <SubmitArticleModal
          uploadArticle={uploadArticle}
          setUploadArticle={setUploadArticle}
        />
        <AakashgangaFooter />
      </div>
    </>
  );
};

export default SocietyEditorialBoardMembers;
